export enum RootActions {
	CONFIGURE = 'ROOT_CONFIGURE'
}
